import cartManager from "./CartManager";
import { ICart, ICartItem } from "../../Interfaces/Cart";
import { ShopSettings } from "../../Interfaces/Shop";
let giftManager: GiftManager;

class GiftManager {
    public static shopSettings = {} as ShopSettings;

    constructor() {
        this.initShopSettings();
    }

    private initShopSettings() {
        GiftManager.shopSettings = JSON.parse(
            (document.querySelector("#shop-settings") as HTMLElement).innerText
        ) as ShopSettings;
    }

    /**
     * Check if free product should be added and add it, if so
     * @param cart
     */
    async handleGifts(cart: ICart) {
        const active = GiftManager.shopSettings.free_product.active,
            available = GiftManager.shopSettings.free_product.available,
            variant_id = GiftManager.shopSettings.free_product.variant_id,
            threshold = GiftManager.shopSettings.free_product.threshold;

        if (active && available && cart.total_price >= threshold) {
            const alreadyThere =
                cart.items.find((i: ICartItem) => String(i.variant_id) === String(variant_id)) !== undefined;
            if (!alreadyThere) {
                await cartManager.simpleAdd(variant_id, 1);
                const newCart = await cartManager.load();
                return newCart;
            }
        }
        return cart;
    }
}

if (document.querySelector("main.cart") || document.querySelector("main.pdp")) {
    giftManager = new GiftManager();
}
export default giftManager;
export { GiftManager };
